import { render, staticRenderFns } from "./content.vue?vue&type=template&id=65ffa32e&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"
import style0 from "./content.vue?vue&type=style&index=0&id=65ffa32e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffa32e",
  null
  
)

export default component.exports